import { useContext } from "react";
import ModuleCard from "../../components/ModuleCard/ModuleCard";
import { IExploreProps } from "./Explore.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { Outlet, useOutlet } from "react-router-dom";
import { ModuleContext } from "../../shared/providers/module/module.provider";

function Explore(props: IExploreProps) {
    const { translate } = useContext(TranslationContext);
    const { pathwayModules } = useContext(ModuleContext);
    const outlet = useOutlet();

    return (
        <>
            {outlet && <Outlet />}
            {!outlet && (
                <div className="pt-11 pt-md-0 px-1 px-md-31 pb-22">
                    <h1 className="text-h2-bd text-h1-bd-md mb-3 mb-md-2">{translate("common.explore", "Explore")}</h1>

                    <section aria-labelledby="topics">
                        <h2 className="text-h3-smbd text-h2-smbd-md mb-13 mb-mb-12" id="topics">
                            {translate("common.all_topics", "All topics")}
                        </h2>
                        <div className="row g-12">
                            {pathwayModules?.map((module) => (
                                <div className="col-12 col-lg-3 d-flex" key={module.id}>
                                    <ModuleCard
                                        {...module}
                                        title={module.title}
                                        contentAmount={module.contentAmount}
                                        description={module.description}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            )}
        </>
    );
}

export default Explore;
